import { cn } from '../design/cn'

/**
 * The one loading indicator, so "busy" looks the same everywhere.
 *
 * Its colour is a token, unlike the shell this is modelled on, where the spinner was
 * `border-blue-600` in four separate files and therefore ignored the theme entirely.
 */
export function Spinner({ full = false }: { full?: boolean }) {
  return (
    <div
      className={cn('flex items-center justify-center', full ? 'h-screen' : 'h-full')}
      role="status"
      aria-label="Loading"
    >
      <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-accent" />
    </div>
  )
}
